import { render, staticRenderFns } from "./ROIChartStorefrontComparison.vue?vue&type=template&id=513ed94a&scoped=true&"
import script from "./ROIChartStorefrontComparison.vue?vue&type=script&lang=js&"
export * from "./ROIChartStorefrontComparison.vue?vue&type=script&lang=js&"
import style0 from "./ROIChartStorefrontComparison.vue?vue&type=style&index=0&id=513ed94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ed94a",
  null
  
)

export default component.exports